<template>
    <div>
        <div class="clearfix">
            <div class="search-container primary mb10 mt10 fr">
                <div class="form-box">
                    <input class="input-field" v-model="filterItems.name" placeholder="请输入零售商名称"/>
                    <button class="search-btn" @click="getMerchantList()"><i class="icon iconfont icon-search"></i></button>
                </div>
            </div>
        </div>
        <div class="column-layout">
            <div v-if="multiSelect" class="table-layout">
                <el-table ref="tableList" :data="merchantList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="multiSelect" type="selection" align="center" :selectable="canSelectRow" width="55"></el-table-column>
                    <el-table-column label="零售商名称" align="left">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{ rows.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标签" align="left">
                        <template slot-scope="rows">
                            <el-tag size="small" v-if="!rows.row.yjFeeSuffient">佣金欠费</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="industryType.name" label="经营模式" align="left"></el-table-column>
                    <el-table-column prop="staffCount" label="公司规模" align="right" width="100"></el-table-column>
                    <el-table-column label="注册资金(元)" align="right" width="140">
                        <template slot-scope="rows">
                            <div v-if="rows.row.registCapital != null">
                                <span>{{ ((rows.row.registCapital).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') }}</span>
                            </div>
                            <div v-else>
                                <span>0.00</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table ref="tableList" :data="merchantList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : hashCheckedRow(rows.row)}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="零售商名称" align="left">
                        <template slot-scope="rows">
                            <span style="padding-top: 5px;padding-left: 20px;display: block">{{ rows.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="标签" align="left">
                        <template slot-scope="rows">
                            <el-tag size="small" v-if="!rows.row.yjFeeSuffient">佣金欠费</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="industryType.name" label="行业类型" align="left"></el-table-column>
                    <el-table-column prop="staffCount" label="公司规模" align="right" width="100"></el-table-column>
                    <el-table-column label="注册资金(元)" align="right" width="140">
                        <template slot-scope="rows">
                            <div v-if="rows.row.registCapital != null">
                                <span>{{ ((rows.row.registCapital).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') }}</span>
                            </div>
                            <div v-else>
                                <span>0.00</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                               layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils, EventBus} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'

    import retailerApi from '../../api/retailer'
    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-biz-union-retailer-for-select',
        desc: '零售商-选择(支持单选和多选)',
        props: {
            //是否为了添加关系商户
            toAddBizRel: {
                type: Boolean,
                default: false
            },
            //是否多选
            multiSelect: {
                type: Boolean,
                default: true
            },
            //单选初始选择项
            initCheckedItem: {
                type: Object,
                default: null
            },
            //多选初始选择项
            initCheckedItems: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            ebChannel: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                //分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //事件总线
                ebProxy: null,
                ebEventName: 'selectVendorOrServicer',
                ebSender: 'retailerForSelect',
                //恢复选择延时毫秒数
                checkedDelay: 300,
                //是否正在恢复选择状态
                checkedIniting: false,
                //列表数据标识列名称
                checkedIdProp: 'id',
                checkedNameProp: 'name',
                //列表vue组件id(ref)
                checkedTblId: 'tableList',
                //所有选中的条目id
                checkedItemIds: [],
                //所有选中的条目id => object
                checkedItemMap: {},
                //禁用的ids(添加合作商户时用)
                disabledItemIds: [],

                //
                merchantList: [],
                //
                filterItems: {
                    name: null
                },
                peerMerchantType: null,
            }
        },
        created: function () {
            //
            this.pageSize = this.pageSizes.first();
            this.peerMerchantType = getEnumInfoWith('merchantType', 'name', 'Retailer').value;
            //
            let self = this;
            //
            if (!this.toAddBizRel) {
                if (this.multiSelect == true) {
                    self.initCheckedItems.forEach(function (item) {
                        self.checkedItemIds.add(item.id);
                        //
                        self.checkedItemMap[item.id + ''] = merge({}, item);
                    });
                } else {
                    if (self.initCheckedItem != null) {
                        let item = self.initCheckedItem;
                        //
                        self.checkedItemIds.add(item.id);
                        //
                        self.checkedItemMap[item.id + ''] = merge({}, item);
                    }
                }
            }
            //
            this.ebProxy = EventBus.get(this.ebChannel);
            this.ebProxy.bind(this.ebEventName, this.handlePeerSelEvent, this);
            //
            self.getMerchantList();
        },
        destroyed() {
            this.ebProxy.unbind(this.ebEventName, this.handlePeerSelEvent);
        },
        methods: {
            handlePeerSelEvent(eventName, eventData, ebSender) {
                let action = eventData.action;
                if (ebSender == this.ebSender) {
                    return;
                }
                let allIds = this.merchantList.pluck(this.checkedIdProp);
                if (action == "add") {
                    let id = eventData.item.id;
                    if (allIds.contains(id) && !this.hashCheckedId(id) && this.multiSelect) {
                        this.toggleListRowById(this.merchantList, id);
                    } else {
                        this.addCheckItem(eventData.item, null);
                    }
                } else if (action == "del") {
                    let id = eventData.id;
                    if (allIds.contains(id) && this.hashCheckedId(id) && this.multiSelect) {
                        this.toggleListRowById(this.merchantList, id);
                    } else {
                        this.delCheckId(id, null);
                    }
                }
            },
            asResultItem(srcItem) {
                return {
                    id: srcItem[this.checkedIdProp],
                    name: srcItem[this.checkedNameProp],
                    type: 3
                };
            },
            //item 接口信息
            addCheckItem: function (item, val) {
                let id = item.id;
                if (!this.multiSelect) {
                    this.checkedItemIds = [];
                    this.checkedItemMap = {};
                }
                //
                if (!this.checkedItemIds.contains(id)) {
                    this.checkedItemIds.add(id);
                    //
                    this.checkedItemMap[id + ''] = item;
                    //
                    return item;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if (self.checkedItemIds.contains(id)) {
                    self.checkedItemIds.remove(id);
                    //
                    delete this.checkedItemMap[id + ''];
                    //
                    return id;
                }
                return null;
            },

            handleCurrentChange: function (val) {
                this.handleSelectionChange([val]);
            },

            handleSelectionChange: function (selRows) {
                let self = this;
                if (self.checkedIniting) {
                    return;
                }
                //列表对应的数据源
                let tableListItems = self.merchantList;
                //
                let allIds = tableListItems.pluck(self.checkedIdProp);
                let selIds = [];
                selRows.forEach(function (row, index) {
                    let item = self.asResultItem(row);
                    selIds.add(item.id);
                    //
                    let effectItem = self.addCheckItem(item);
                    //
                    if (effectItem != null) {
                        self.ebProxy.trigger(self.ebEventName, {
                            action: 'add',
                            item: effectItem,
                        }, self.ebSender);
                    }
                });

                let lessIds = Utils.compareArrays(selIds, allIds)["less"];
                lessIds.forEach(function (id, index) {
                    let effectId = self.delCheckId(id);
                    //
                    if (effectId != null) {
                        self.ebProxy.trigger(self.ebEventName, {
                            action: 'del',
                            id: effectId,
                        }, self.ebSender);
                    }
                })
            },
            restoreSelRows(dataRows) {
                let self = this;
                self.checkedIniting = true;
                let allIds = dataRows.pluck(this.checkedIdProp);
                let selIds = Utils.compareArrays(allIds, this.checkedItemIds)["same"];
                if (self.multiSelect) {
                    selIds.forEach(function (id) {
                        self.toggleListRowById(dataRows, id);
                    });
                }
                //
                setTimeout(function () {
                    self.checkedIniting = false;
                }, 100);
            },

            hashCheckedId(id) {
                return this.checkedItemIds.contains(id);
            },

            hashCheckedRow(row) {
                let checkId = row[this.checkedIdProp];
                return this.checkedItemIds.contains(checkId);
            },
            toggleListRowById(dataRows, idVal) {
                let self = this;
                //
                let refTbl = self.$refs[self.checkedTblId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[self.checkedIdProp] == idVal;
                });
                if (theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },

            // ===================== 分页多选结束 ==============================
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                //
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if (this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                //
                this.pageNumber = val;
                //
                this.getMerchantList();
            },

            canSelectRow(row, index) {
                return !this.disabledItemIds.contains(row[this.checkedIdProp]);
            },

            getMerchantList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                if (!Utils.isNoB(self.filterItems['name'])) {
                    filterItems.name = self.filterItems['name'];
                }
                filterItems.disabled = false;
                filterItems.applyState = 2;
                filterItems.auditState = 1;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                retailerApi.getRetailerList(postData, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        let resultData = result.data;
                        //
                        let pagination = resultData.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.merchantList = resultData.rows;
                        if (self.toAddBizRel) {
                            // 添加商户关系，参考retailer招标
                        }
                        //
                        setTimeout(function () {
                            self.restoreSelRows(self.merchantList);
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let multiSelect = self.multiSelect;
                if (multiSelect) {

                    result.data = self.checkedItemIds.map(function (id) {
                        return self.checkedItemMap[id + ''];
                    });

                } else {
                    let checkedItemId = self.checkedItemIds.first();
                    if (checkedItemId != null) {
                        result.data = this.checkedItemMap[checkedItemId + ''];
                    }
                }
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/bizUnion/BizUnionRetailerForSelect.vue